<template>
    <div class="row">
        <div class="col-md-12 card-wrapper">
            <div class="card">
                <div class="row m-0">
                    <div class="card-header crm-modal-header hpx-50 d-flex align-items-center col-8">{{$ml.get('ACOUNT_MAIL_SETTING')}}</div>
                    <div class="card-header crm-modal-header hpx-50 d-flex align-items-center justify-content-end col-4 "> 
                        <select v-model="selectedQuickConf" class="new-input email_type">
                        <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                        <option v-for="(conf,index) in quickConf" :key="index">{{conf.name}}</option>
                        </select>
                    </div>
                </div>
               
                <div class="card-body bg-light color-gray">
                    <form>
                        <div class="form-group row">
                            <label for="username" class="col-sm-2 col-form-label">{{$ml.get('USER_NAME')}} *</label>
                            <div class="col-sm-10">
                            <input type="text"  class="new-input" id="username" v-model="form.username" :placeholder="$ml.get('USER_NAME')">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="password" class="col-sm-2 col-form-label">{{$ml.get('PASSWORD')}} *</label>
                            <div class="col-sm-10">
                            <input type="password" class="new-input" id="password" v-model="form.password" placeholder="*****">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="popServer" class="col-sm-2 col-form-label">{{$ml.get('POP_SERVER')}} *</label>
                            <div class="col-sm-7">
                            <input type="text" class="new-input" id="popServer" v-model="form.popServer" :placeholder="$ml.get('POP_SERVER')">
                            </div>
                            <label for="popPort" class="col-sm-1 col-form-label">{{$ml.get('PORT')}} *</label>
                            <div class="col-sm-2">
                                <select name="popPort" id="popPort" v-model="form.popPort" class="new-input">
                                    <option value="110">110</option>
                                    <option value="143">143</option>
                                    <option value="993">993</option>
                                    <option value="995">995</option>
                                    <option value="1110">1110</option>
                                    <option value="2221">2221</option>
                                </select>
                            </div>
                        </div>
                    </form>
                    <div class="form-check">
                        <input class="form-check-input mt-0" type="checkbox" id="leaveACopyOnServer" v-model="form.leaveACopyOnServer">
                        <label class="form-check-label" for="leaveACopyOnServer">
                                {{$ml.get('LEAVE_COPY_MESSAGE')}}
                        </label>
                    </div>
                    
                    <hr>
                    
                    <div class="form-group row">
                        <label for="identity" class="col-sm-2 col-form-label">{{$ml.get('VISIBLE_NAME')}}</label>
                        <div class="col-sm-10">
                        <input type="identity" class="new-input" id="identity" v-model="form.identity">
                        </div>
                    </div>

                    <hr>
                    
                    <p class="color-black">{{$ml.get('SEND_SMTP_SERVER')}}</p>
                    <div class="form-group row">
                        <label for="smtpServer" class="col-sm-2 col-form-label">{{$ml.get('SMTP_SERVER')}} *</label>
                        <div class="col-sm-7">
                        <input type="text"  class="new-input" id="smtpServer" v-model="form.smtpServer" placeholder="smtp sunucu">
                        </div>  
                        <label for="smtpPort" class="col-sm-1 col-form-label">{{$ml.get('PORT')}} *</label>
                        <div class="col-sm-2">
                            <select name="smtpPort" id="smtpPort" v-model="form.smtpPort" class="new-input">
                                <option value="25">25</option>
                                <option value="465">465</option>
                                <option value="587">587</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="card-footer crm-modal-footer text-right">
                    <button class="btn " @click="resetForm">{{$ml.get('CANCEL')}}</button>
                    <button class="btn bg-new-primary w-150p " @click="upsertEmailSettingF">{{$ml.get('SAVE')}}</button>
                </div>
            </div>
        </div>
        <div class="modal fade" id="updateSetting" ref="successPayment" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle2" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:800px!important">
                <div class="modal-content mcBgGrey">
                    <div class="modal-body">
                        <div class="row text-align">
                            <div class="col mt-4 mb-4">
                                <div class="row justify-content-md-center f-w-semibold text-center mt-4 mb-4">{{updatedetails}}</div>
                                <div class="row justify-content-md-center"><button type="button" class="btn SettingsBtn d-inline-block" data-dismiss="modal">{{$ml.get('TURN_BACK')}}</button></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
    </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters,mapActions} from 'vuex'
export default {
    data () {
        return {
            form:{
                username:'',
                password:'',
                popServer:'',
                popPort:'',
                leaveACopyOnServer:true,
                smtpServer:'',
                smtpPort:''
            },
            updatedetails:'',
            selectedQuickConf:"",
            quickConf:[
            {
                "name":"yandex",
                "imap":{
                    "host":"imap.yandex.com.tr",
                    "security":"ssl",
                    "port":993
                },
                "smtp":{
                    "host":"smtp.yandex.com.tr",
                    "security":"ssl",
                    "port":465
                }
            },
            {
                "name":"gmail",
                "imap":{
                    "host":"imap.gmail.com",
                    "security":"tls",
                    "port":993,
                    "authentication": "oauth"
                },
                "smtp":{
                    "host":"smtp.gmail.com",
                    "security":"tls",
                    "port":465,
                    "authentication": "oauth"
                }
            },
            {
                "name":"outlook",
                "imap":{
                    "host":"outlook.office365.com",
                    "security":"tls",
                    "port":993
                },
                "smtp":{
                    "host":"smtp.office365.com",
                    "security":"starttls",
                    "port":587
                }
            },
            {
                "name":"ihs-domain.com",
                "imap":{
                    "host":"mail.domain.com",
                    "port":143
                },
                "smtp":{
                    "host":"mail.domain.com",
                    "port":587
                }
            }
            ]
    }
    },
    components:{
    },
    computed:{
        ...mapGetters(['email_setting']),
    },
    watch:{
        "selectedQuickConf":function(){
            var data = this.quickConf.find(x=>x.name==this.selectedQuickConf);
            console.log(data);
            this.form.popPort= data.imap.port;
            this.form.smtpServer=data.smtp.host;
            this.form.popServer=data.imap.host
            this.form.smtpPort=data.smtp.port
        },
    },
    methods:{
        ...mapActions([
            'updateLoading'
        ]),
        checkInput(){
            var requiredList = ['username','password','popServer', 'popPort', 'smtpServer', 'smtpPort']
            var translateObj = {
                "username":this.$ml.get('USER_NAME'),
                "password":this.$ml.get('PASSWORD'),
                "popServer":this.$ml.get('POP_SERVER'),
                "popPort":this.$ml.get('PORT'),
                "smtpServer":this.$ml.get('SMTP_SERVER'),
                "smtpPort":this.$ml.get('PORT')
            }
            var state = true
            for(let i in requiredList){
                if(this.form[requiredList[i]]===''||this.form[requiredList[i]]===undefined){
                    this.$notify({ group: 'foo',
                        type: 'warn', 
                        title: this.$ml.get('WARNING'),
                        text: translateObj[requiredList[i]]+' '+this.$ml.get('IS_REQUIRED')
                    })
                    state = false
                }
            }
            return state
            
        },
        upsertEmailSettingF(){
            var checkStatus = this.checkInput()
            if(checkStatus){
                this.$store.dispatch('upsertEmailSetting',this.form).then(() => {
                    this.updatedetails=this.$ml.get('MAIL_ACCOUNT_SETTING_UPDATED')
                    $('#updateSetting').modal('show');
                })
                .catch(e => {
                    this.updatedetails=this.$ml.get('MAIL_ACCOUNT_SETTING_NOT_UPDATED')
                    $('#updateSetting').modal('show');
                })
            }
        },
        getEmailSettingF(){
             
            this.$store.dispatch('getEmailSetting',this.form).then(() => {
                console.log('--getEmailSetting then')
                this.form=this.email_setting
                if(this.email_setting.leaveACopyOnServer!==null){
                    this.form.leaveACopyOnServer = true
                }
                
            })
            .catch(e => {
                console.log(e)
                 
            })
        },
        resetForm(){

        }
    },
    created(){
        this.getEmailSettingF()
    }
}

</script>
<style scoped>
.w-150p{
    width: 150px;
}
.mt-0{
    margin-top:0px;
}
@media(max-width: 720px){
    .card-header .new-input{
        min-width: 110px;
        padding: 2px;
    }
    .email_type{
        min-width: 140px !important;
    }

}
</style>